import { render, staticRenderFns } from "./ImagePreviewButton.vue?vue&type=template&id=3ff83fb1"
import script from "./ImagePreviewButton.vue?vue&type=script&lang=js"
export * from "./ImagePreviewButton.vue?vue&type=script&lang=js"
import style0 from "./ImagePreviewButton.vue?vue&type=style&index=0&id=3ff83fb1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports